export default __webpack_public_path__ + "static/media/Case-Eventos.52e74d36.jpg";